import { useContext } from 'react';
import { LanguageContext } from '../../../../contexts/LanguageContext';
import * as Style from './styles';

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const onLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLanguage(event.target.value);
  };

  return (
    <Style.Container>
      <Style.Label>
        <input
          type="radio"
          name="language"
          value="pt-BR"
          checked={language === 'pt-BR'}
          onChange={e => onLanguageChange(e)}
        />
        <span className={language === 'pt-BR' ? 'active' : ''}>PT</span>
      </Style.Label>
      <Style.Label>
        <input
          type="radio"
          name="language"
          value="en-US"
          checked={language === 'en-US'}
          onChange={e => onLanguageChange(e)}
        />
        <span className={language === 'en-US' ? 'active' : ''}>EN</span>
      </Style.Label>
    </Style.Container>
  );
};

export default LanguageSelector;
